import React, { useState } from 'react';
import JobSurveyDataTable from "../../datatables/JobSurveyDataTable";
import JobSurveyShowPage from "../JobSurveyShowPage";
import ReactDOM from "react-dom";
import {DELIVERY_PAGES} from "../JobOrderDeliveryPage";

export const SURVEY_PAGES = {
    INDEX:  'index',
    SHOW:   'show'
}

const JobSurveyPage = (props) => {
    const {
        jobId       = null,
        surveyId    = null,
        page        = SURVEY_PAGES.INDEX,
        parentId    = "",
    } = props;

    const [currentPage, setCurrentPage]             = useState(page);
    const [selectedJobSurvey, setSelectedJobSurvey] = useState(!!surveyId ? {id: surveyId} : null);

    const handleChangePage = (page, survey) => {
        setCurrentPage(page);
        setSelectedJobSurvey(survey);
    }

    switch (currentPage) {
        case SURVEY_PAGES.SHOW:
            return (
                <JobSurveyShowPage
                    jobId={jobId}
                    surveyId={!!selectedJobSurvey ? selectedJobSurvey.id : null}
                    onChangePage={(page, survey) => handleChangePage(page, survey)}
                />
            )
        case SURVEY_PAGES.INDEX:
        default:
            return (
                <JobSurveyDataTable
                    jobId={jobId}
                    onChangePage={(page, survey) => handleChangePage(page, survey)}
                    parentId={parentId}
                />
            )
    }
}

export default JobSurveyPage

const target = document.getElementById('job-survey-page');
if (target) {
    const {
        jobId       = null,
        surveyId    = null,
        page        = SURVEY_PAGES.INDEX,
        parentId    = 'job-survey-page'
    } = target.dataset;

    ReactDOM.render(
        <JobSurveyPage
            jobId={jobId}
            surveyId={surveyId}
            page={page}
            parentId={parentId}
        />
    , target);
}
